import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { Home, SportsEsports, Search, Favorite } from '@mui/icons-material';
import styles from './Header.module.css';

const Header: React.FC = () => {
  const favoritesCount = useSelector((state: RootState) => state.favorites.items.length);

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <Link to="/" className={styles.logo}>
          <img src="/game-catalogue/logo.svg" alt="GameStore Logo" />
          <span>GameCatalogue</span>
        </Link>
        
        <nav className={styles.nav}>
          <NavLink
            to="/"
            className={({ isActive }) => 
              isActive ? `${styles.link} ${styles.active}` : styles.link
            }
            end
          >
            <Home />
            Главная
          </NavLink>
          
          <NavLink
            to="/games"
            className={({ isActive }) => 
              isActive ? `${styles.link} ${styles.active}` : styles.link
            }
          >
            <SportsEsports />
            Игры
          </NavLink>
          
          <NavLink
            to="/search"
            className={({ isActive }) => 
              isActive ? `${styles.link} ${styles.active}` : styles.link
            }
          >
            <Search />
            Поиск
          </NavLink>
          
          <NavLink
            to="/favorites"
            className={({ isActive }) => 
              isActive ? `${styles.link} ${styles.active}` : styles.link
            }
          >
            <Favorite />
            Избранное
            {favoritesCount > 0 && (
              <span className={styles.favoritesBadge}>{favoritesCount}</span>
            )}
          </NavLink>
        </nav>
      </div>
    </header>
  );
};

export default Header;